import React from 'react';
import Fieldset from './Fieldset';
import Select from './Select';

export type SelectFieldsetOption = {
  value: string;
  label: string;
  disabled?: boolean;
  placeholder?: boolean;
};

export interface SelectFieldsetProps extends Omit<
  React.SelectHTMLAttributes<HTMLSelectElement>,
  'children'
> {
  id: string;
  htmlFor: string;
  fieldsetClassName?: string;
  className?: string;
  label?: React.ReactNode;
  hint?: React.ReactNode;
  hintClassName?: string;
  hintId?: string;
  hintHidden?: boolean;
  options: SelectFieldsetOption[];
}

const SelectFieldset = React.forwardRef<HTMLSelectElement, SelectFieldsetProps>(
  (
    {
      id,
      htmlFor,
      fieldsetClassName,
      className = '',
      options,
      label,
      hint,
      hintClassName,
      hintId,
      hintHidden,
      ...props
    },
    ref
  ) => {
    return (
      <Fieldset id={id} htmlFor={htmlFor} fieldsetClassName={fieldsetClassName}>
        <Select
          id={id}
          ref={ref}
          className={className}
          options={options}
          label={label}
          hint={hint}
          hintClassName={hintClassName}
          hintId={hintId}
          hintHidden={hintHidden}
          {...props}
        />
      </Fieldset>
    );
  }
);

SelectFieldset.displayName = 'SelectFieldset';

export default SelectFieldset;
